import { AppBar, Toolbar, Box, Button, SvgIcon, Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useState } from "react";
import { ReactComponent as MenuIcon } from "../../assets/icons/hamburger.svg";
import OhmMenu from "./OhmMenu.jsx";
import ThemeSwitcher from "./ThemeSwitch.jsx";
import LocaleSwitcher from "./LocaleSwitch.tsx";
import ConnectMenu from "./ConnectMenu.jsx";
import { ReactComponent as XPHIcon } from "../../assets/icons/xph-topbar.svg";
import { NavLink, useHistory } from "react-router-dom";
import "./topbar.scss";

const useStyles = makeStyles(theme => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: "100%",
      padding: "10px",
    },
    justifyContent: "flex-end",
    alignItems: "flex-end",
    background: "transparent",
    backdropFilter: "none",
    zIndex: 10,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("981")]: {
      display: "none",
    },
  },
}));

function TopBar({ theme, toggleTheme, handleDrawerToggle }) {
  const [isHovering, setIsHovering] = useState(false);
  const history = useHistory();
  const classes = useStyles();

  const isVerySmallScreen = useMediaQuery("(max-width: 355px)");
  const isSmallerScreen = useMediaQuery("(max-width: 980px)");
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const buttonStyles = isHovering ? " hovered-button" : "";

  return (
    <AppBar position="sticky" className={`${classes.appBar} `} elevation={0}>
      <Toolbar disableGutters className={`dapp-topbar `}>
        <Button
          id="hamburger"
          aria-label="open drawer"
          edge="start"
          size="large"
          variant="contained"
          color="secondary"
          onClick={handleDrawerToggle}
          className={classes.menuButton}
        >
          <SvgIcon component={MenuIcon} />
        </Button>

        <Box display="flex">
          {/* {!isVerySmallScreen && <OhmMenu />} */}
          <ConnectMenu theme={theme} />
          <LocaleSwitcher theme={theme} />
          {/* <ThemeSwitcher theme={theme} toggleTheme={toggleTheme} /> */}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
